
import './extend'
import './polyfills'

import Vue from 'vue'

import store from './Store'
import vuetify from './Plugins/vuetify'

import { App, plugin as InertiaPlugin } from '@inertiajs/inertia-vue'
Vue.use(InertiaPlugin)

import './Plugins/axios'
import Api from './Plugins/api'
Object.defineProperty(Vue.prototype, '$api', { get: () => Api })

import Logs from './Mixins/Logs'
Vue.mixin(Logs)

import './Assets/roboto.css'

window.$vm = new Vue({
  store,
  vuetify,
  render: h => h(App, {
    props: {
      initialPage: JSON.parse(document.getElementById('app').dataset.page),
      resolveComponent: name => require(`./Pages/${name}`).default,
    },
  }),
}).$mount('#app')

import './exposed'
